import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import Logo from "./Logo";

interface LogoWithBackgroundProps {
  variant?: "default" | "gradient";
  size?: number;
  backgroundSize?: number;
}

export default function LogoWithBackground({
  variant = "default",
  size = 32,
  backgroundSize,
}: LogoWithBackgroundProps) {
  // Default background size is ~1.8x the logo size for good padding
  const defaultBackgroundSize = Math.round(size * 1.8);
  const finalBackgroundSize = backgroundSize || defaultBackgroundSize;

  return (
    <Styled.Container variant={variant} size={finalBackgroundSize}>
      <Styled.LogoWrapper size={size}>
        <Logo />
      </Styled.LogoWrapper>
    </Styled.Container>
  );
}

/* Styled Components
======================================================= */
const Styled: any = {};

Styled.Container = styled.div<{ variant: string; size: number }>((props) => {
  const t = props.theme;
  return css`
    label: LogoWithBackground;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${props.size}px;
    height: ${props.size}px;
    ${props.variant === "gradient" &&
    css`
      background: linear-gradient(106.26deg, #fbd7ff 4.26%, #ffe4cc 95.3%, #ffdec1 95.3%);
      border-radius: 8px;
    `}
  `;
});

Styled.LogoWrapper = styled.div<{ size: number }>((props) => {
  const t = props.theme;
  return css`
    label: LogoWrapper;
    height: ${props.size}px;
    width: auto;

    svg {
      height: ${props.size}px;
      width: auto;
    }
  `;
});
